module.exports = __webpack_public_path__ + "img/img_charge_banner.bfe4c7d3.png";